import { createTheme, ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { useAtomValue } from "jotai";
import { currentTheme } from "../atoms";
import React from "react";

function getMuiTheme(theme: string) {
  switch (theme) {
    case "light":
      return createTheme({});
    case "blue":
      return createTheme({
        components: {
          MuiBadge: {
            styleOverrides: {
              badge: {
                backgroundColor: "#9c27b0",
              },
            },
          },
        },
      });
    default:
      return createTheme({});
  }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const theme = useAtomValue(currentTheme);
  const muiTheme = getMuiTheme(theme);
  return <MuiThemeProvider theme={muiTheme}>{children}</MuiThemeProvider>;
};
